import styled from "styled-components";

import { Icon } from "@/components/ui-deprecated";

export const PageStyled = styled.div`
    height: 100%;
    width: 100%;
    padding: 3rem;
`;

export const Container = styled.div`
    padding: 1rem 1.5rem;

    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.grayDairy};
    border-radius: 0.5rem;
    box-shadow: 0px 2px 5px #dedbd666;
`;

export const Title = styled.div`
    margin-bottom: 1rem;

    display: flex;
    align-items: center;

    font-size: 1.25rem;
    font-weight: 500;
    color: ${({ theme }) => theme.color.textGray};
`;

export const IconStyled = styled(Icon)`
    margin-right: 0.5rem;

    color: ${({ theme }) => theme.color.textGrayDairyDarker};
`;

export const Content = styled.div`
    margin-bottom: 1rem;
`;
